import React, { FC } from "react";
import { Select } from "antd";

interface IProps {}

/**
 * @author
 * @function @
 **/

const YearDropDown = (props) => {
  const { actions } = props;
  const onChange = (value: any) => {
    actions(value);
  };

  const startYear = 2021;
  const currentYear = new Date().getFullYear();

  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push({ value: year, label: `${year}` });
  }

  const onSearch = (value: string) => {
    //   console.log('search:', value);
  };
  return (
    <Select
      style={{ width: "200px" }}
      defaultValue={currentYear}
      showSearch
      placeholder="Select Year"
      optionFilterProp="label"
      onChange={onChange}
      onSearch={onSearch}
      options={years}
    />
  );
};
export default YearDropDown;
